if (!customElements.get('scroll-to-top-button')) {
  class ScrollToTopButton extends HTMLElement {
    constructor() {
      super();
      this.isRevealed = null;
      this.onScrollHandler = this.onScroll.bind(this);
      this.onClickHandler = this.scrollToTop.bind(this);
      this.onKeyDownHandler = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      // Initial state
      this.updateVisibility();

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onScrollHandler);
      document.addEventListener('bt:footer-visibility', this.onScrollHandler);
      window.visualViewport?.addEventListener('resize', this.onScrollHandler);
      this.addEventListener('click', this.onClickHandler);
      this.addEventListener('keydown', this.onKeyDownHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onScrollHandler);
      document.removeEventListener('bt:footer-visibility', this.onScrollHandler);
      window.visualViewport?.removeEventListener('resize', this.onScrollHandler);
      clearTimeout(this.focusTimer);
      cancelAnimationFrame(this.frame);
      this._ticking = false;
      this.removeEventListener('click', this.onClickHandler);
      this.removeEventListener('keydown', this.onKeyDownHandler);
    }

    onScroll() {
      // Schedule all DOM reads/writes in one animation frame
      if (this._ticking) return;
      this._ticking = true;

      this.frame = requestAnimationFrame(() => {
        this._ticking = false;
        this.updateVisibility();
      });
    }

    updateVisibility() {
      // Keep this protection independent of the loyalty app loading.
      const formRect = document.querySelector('.bt-newsletter__form')?.getBoundingClientRect();
      const buttonRect = this.getBoundingClientRect();
      const overlapsNewsletter = Boolean(formRect && formRect.width > 0 && formRect.height > 0
        && buttonRect.width > 0 && buttonRect.height > 0
        && buttonRect.left < formRect.right && buttonRect.right > formRect.left
        && buttonRect.top < formRect.bottom && buttonRect.bottom > formRect.top);
      document.documentElement.toggleAttribute('data-bt-newsletter-top-overlap', overlapsNewsletter);
      // Read scroll position once per frame, not on every event
      const shouldReveal = window.scrollY > window.innerHeight
        && !document.documentElement.hasAttribute('data-bt-footer-visible')
        && !overlapsNewsletter;
      if (shouldReveal !== this.isRevealed) {
        this.isRevealed = shouldReveal;
        this.classList.toggle('reveal', shouldReveal);
        this.tabIndex = shouldReveal ? 0 : -1;
        this.setAttribute('aria-hidden', String(!shouldReveal));
      }
    }

    scrollToTop() {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'instant' : 'smooth' });
      clearTimeout(this.focusTimer);

      // Wait until scroll completes before focusing (simple heuristic)
      this.focusTimer = setTimeout(() => {
        document.querySelector('.skip-to-content-link')?.focus({ preventScroll: true });
      }, reducedMotion ? 0 : 700);
    }

    onKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.scrollToTop();
      }
    }
  }

  customElements.define('scroll-to-top-button', ScrollToTopButton);
}
